<template>
  <div>
    <BannerSection class="ts-bg-white" />
    <!-- <LotteryTimeSection class="ts-bg-white" /> -->
    <JacpotSection class="ts-bg-white" />
    <ResultSection class="ts-bg-white" />
    <ChooseUs class="ts-bg-white" />
    <WorkStep class="ts-bg-white" />
  </div>
</template>

<script>

import BannerSection from './components/banner/banner-selection'
import LotteryTimeSection from './components/lottery-time-section'
import JacpotSection from './components/jackpot-section'
import ResultSection from './components/result-section'
import ChooseUs from './components/choose-us'
import WorkStep from './components/work-step'

export default {
  components: {
    BannerSection,
    LotteryTimeSection,
    JacpotSection,
    ResultSection,
    ChooseUs,
    WorkStep
  },
  data() {
    return {
      isOpen: false
    }
  }
}
</script>
